<template>
<div>
  <v-dialog v-model="dialogMember" persistent max-width="800px">
  <OverlayLoading :loading="loading" />
    <v-card class="pa-3">
      <v-card-title>
        <span class="dialog-memeber-title">ข้อมูลสมาชิก</span>
        <v-row justify="end" style="margin-top: -3%;">
          <v-btn
            x-small
            icon
            @click="closeDialog"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-row>
      </v-card-title>
      <v-card-text>
        <!-- <v-row v-if="this.leaderName === '-'" justify="space-around">
          <span class="txt-leader-title">ยังไม่มีข้อมูลหัวหน้า</span>
        </v-row> -->
        <v-row class="mt-0" justify=center>
          <v-col cols="12">
            <v-divider></v-divider>
          </v-col>
        </v-row>
        <v-row class="mb-3">
          <v-col cols="4">
            <p class="txt-font" style="margin-top: 0%;">สายงาน</p>
            <span class="txt-font" style="color: #333;">{{leaderLineOfWork}}</span>
          </v-col>
          <v-col cols="4" class="justify-start align-start">
            <p class="txt-font" style="margin-top: 0%;">สายบังคับบัญชา</p>
            <span class="txt-font" style="color: #333;">{{leaderChartHeader}}</span>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="4">
            <p class="txt-font" style="margin-top: 0%;">ผู้บังคับบัญชา</p>
          </v-col>
        </v-row>
        <v-row v-if="this.leaderName === '-'" >
          <v-col cols="4" class="ml-2" style="margin-top: -3%;">
            <span class="txt-font" style="color: #333;">-</span>
          </v-col>
        </v-row>
        <v-row v-else no-gutters class="mt-0 pa-1" style="background-color: #F8F9FB;">
          <v-col cols="1" sm="12" md="12" lg="1" class="d-flex flex-column justify-center" style="">
            <v-avatar
              size="64"
              rounded
            >
              <v-img
                class="card-header-userimg-border"
                cover
                :lazy-src="require('@/assets/icons/no_user.png')"
                :src="failed_imageLeader ? require('@/assets/icons/no_user.png') : leaderImage"
                v-on:error="onImgErrorLeader()"
                aspect-ratio="2.7"
                height="100%"
              />
            </v-avatar>
            <!-- <span class="label-codeid txt-font mt-5">รูปภาพประจำตัว</span> -->
          </v-col>
          <v-col
            cols="11"
            class="ml-0"
          >
          <v-row class="ml-5">
            <v-col cols="6">
              <p class="txt-font" style="margin-top: 0%;">ชื่อ-นามสกุล</p>
              <span class="txt-font" style="color: #333333;">{{leaderName || '-'}}</span>
            </v-col>
            <v-col cols="6" class="justify-start align-start">
              <p class="txt-font" style="margin-top: 0%;">อีเมล</p>
              <span class="txt-font" style="color: #333333;">{{leaderEmail || '-'}}</span>
            </v-col>
          </v-row>
          </v-col>
        </v-row>
        <v-container style="padding: 0px;">
          <!-- <TableMember/> -->
        <v-row v-if="tab === 0 || tab === 1">
          <v-col cols="7" class="mt-5">
          </v-col>
          <v-col cols="5" class="pt-0 d-flex flex-row align-center justify-end">
            <v-spacer/>
            <!-- <v-autocomplete
              v-model="search"
              :items="selectFilter"
              item-text="name"
              item-value="_id"
              outlined
              dense
              clearable
              class="mt-2"
              placeholder="ค้นหาจากชื่อ - นามสกุล"
              no-data-text="ไม่พบข้อมูล"
              @change="initDataTable(), page=1"
              @click:clear="search='', initDataTable(), page=1"
            >
            <template v-slot:append>
              <img width="24" height="24" src="@/assets/icons/search-icon-2.png" style="cursor: pointer;" @click="searchFilterData(), page=1">
            </template>
            </v-autocomplete> -->
            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              outlined
              dense
              clearable
              class="mt-3"
              label="ค้นหาชื่อพนักงาน"
              single-line
              hide-details
            ></v-text-field>
          </v-col>
        </v-row>
        <v-tabs
          v-model="tab"
          style="margin-top: 0px;"
          color="#2BA197"
        >
        <!-- background-color="titlebackground" -->

        <v-tabs-slider class="ml-2" color="#2BA197"></v-tabs-slider>

        <v-tab v-for="item in items" :key="item.nameBusiness" style="font-size:16px">
          <!-- {{ item }} -->
          <span class="ml-2">{{ item.nameBusiness }}</span>
          <!-- <v-chip
            class="ml-2"
            color="#FEF5E9"
            text-color="#E9A016"
            small
          >
            <span>{{item.count}}</span>
          </v-chip> -->
        </v-tab>
        <v-row v-if="tab === 1">
          <v-col cols="12" class="pt-0 d-flex flex-row align-center justify-end">
            <!-- ถ้าเป็น super admin จะเห็น -->
            <!-- <v-btn
            v-show="approveRole === 'Super Admin'"
              outlined
              color="#fff"
              dark
              class=""
              @click="openDialogAddAprover('add', '', '', 'approver')"
            >
            <v-icon left dark color="#2BA197" size="14px">fa-plus</v-icon>
            <span class="ra-text-in-button-employee" style="color: #2BA197;">
              เพิ่มข้อมูลพนักงาน
            </span>
            </v-btn> -->
            <!-- แก้ไขใหม่เห็นทุกสิทธิ์  -->
            <v-btn
              v-if="rights.create"
              outlined
              color="#fff"
              dark
              class=""
              @click="openDialogAddAprover('add', '', '', 'approver')"
            >
            <v-icon left dark color="#2BA197" size="14px">fa-plus</v-icon>
            <span class="ra-text-in-button-employee" style="color: #2BA197;">
              เพิ่มข้อมูลพนักงาน
            </span>
            </v-btn>
          </v-col>
        </v-row>

        <v-tabs-items v-model="tab">
          <v-tab-item>
            <div class="my-0">
              <div>
                <!-- <tableAgency/> -->
                <v-row v-if="dataMember.length === 0" class="mt-2 rounded-lg" justify="center" fixed centered style="background-color: #fff; height: 300px;">
                  <v-col cols="8">
                  </v-col>
                  <v-col cols="8" class="text-center mt-12" style="margin-top: 5%;">
                    <img width="150" height="110" src="@/assets/icons/create-employee.png">
                    <p class="" style="font-weight: bold;">ยังไม่มีข้อมูลพนักงาน</p>
                    <!-- <p class="ra-head-text">ค้นหาพนักงานที่คุณต้องการเพิ่ม</p> -->
                  </v-col>
                  <v-col cols="8" class="pt-0 pb-0 d-flex align-center justify-center mt-4" style="margin-top: -1%;">
                  </v-col>
                  <div
                    class="pt-0 d-flex flex-row align-center justify-end"
                    color="grey lighten-2"
                    flat
                    tile
                  ></div>
                </v-row>
                <v-data-table
                  v-else
                  :headers="headers"
                  :items="dataMember"
                  class="elevation-0"
                  :search="search"
                  :loading="loading"
                  loading-text="Loading... Please wait"
                  :footer-props="{
                    'items-per-page-options': [15, 30, 50, 100, -1],
                    'items-per-page': 15
                  }"
                  :server-items-length="total || -1"
                  @update:items-per-page="changePerPage"
                  @update:page="changePage"
                  disable-sort
                  dense
                  :page.sync="pagination.current"
                >
                  <template v-slot:[`item.memberImg`]="{ item }">
                    <td style="width: fit-content !important;" class="py-2">
                      <v-avatar
                        size="50"
                        rounded
                      >
                      <v-img
                        class="img-border"
                        :src="item.failed_image ? require('@/assets/icons/no_user.png') : item.memberImg"
                        v-on:error="onImgError(item.no-1)"
                        aspect-ratio="2.7"
                      />
                      </v-avatar>
                    </td>
                  </template>
                  <template v-slot:[`item.actions`]="{ item }">
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }"
                      >
                        <v-btn
                          v-bind="attrs"
                          v-on="on"
                          rounded
                          small
                          dark
                          icon
                          class="mt-3 mb-3"
                          @click="openDialogAddAprover('edit', item, dataSecLeader.indexOf(item), 'approver')"
                        >
                          <template v-slot>
                            <v-icon small dark class="icon-eye-color">mdi-pencil-outline</v-icon>
                          </template>
                        </v-btn>
                      </template>
                      <span class="label-table-action">จัดการผู้ดูแล</span>
                    </v-tooltip>
                    <v-tooltip bottom>
                      <template v-slot:activator="{ attrs }">
                        <v-btn
                          v-bind="attrs"
                          rounded
                          dark
                          small
                          icon
                          class="mt-3 mb-3 ml-2"
                          @click="checkRemove(item, 'approver')"
                        >
                          <template v-slot>
                            <v-icon small dark color="error">mdi-delete-outline</v-icon>
                          </template>
                        </v-btn>
                      </template>
                      <span class="label-table-action">ลบผู้ดูแล</span>
                    </v-tooltip>
                  </template>
                </v-data-table>
              </div>
            </div>
          </v-tab-item>
          <v-tab-item>
            <div class="my-0">
              <div>
                <v-row v-if="dataSecLeader.length === 0" class="mt-2 rounded-lg" justify="center" fixed centered style="background-color: #fff; height: 300px;">
                  <v-col cols="8">
                  </v-col>
                  <v-col cols="8" class="text-center mt-12" style="margin-top: 5%;">
                    <img width="150" height="110" src="@/assets/icons/create-employee.png">
                    <p class="" style="font-weight: bold;">ยังไม่มีข้อมูลพนักงาน</p>
                    <!-- <p class="ra-head-text">ค้นหาพนักงานที่คุณต้องการเพิ่ม</p> -->
                  </v-col>
                  <v-col cols="8" class="pt-0 pb-0 d-flex align-center justify-center mt-4" style="margin-top: -1%;">
                  </v-col>
                  <div
                    class="pt-0 d-flex flex-row align-center justify-end"
                    color="grey lighten-2"
                    flat
                    tile
                  ></div>
                </v-row>
                <!-- สิทธิ์ super admin -->
                <!-- <v-data-table
                  v-else
                  :headers="approveRole === 'Super Admin' ? headersSecLeaderAdmin : headersSecLeader"
                  :items="dataSecLeader"
                  class="elevation-0"
                  :search="search"
                  :loading="loading"
                  loading-text="Loading... Please wait"
                  :footer-props="{
                    'items-per-page-options': [15, 30, 50, 100, -1],
                    'items-per-page': 15
                  }"
                  :server-items-length="total || -1"
                  @update:items-per-page="changePerPage"
                  @update:page="changePage"
                  disable-sort
                  dense
                  :page.sync="pagination.current"
                >
                  <template v-slot:[`item.userImg`]="{ item }">
                  <td style="width: fit-content !important;" class="py-3">
                    <v-avatar
                      size="50"
                      rounded
                      >
                      <v-img
                        class="card-header-userimg-border"
                        cover
                        :src="item.failed_image ? require('@/assets/icons/no_user.png') : item.userImg"
                        :alt="item.employeeId"
                        v-on:error="onImgErrorSecLeader(item.approverNo)"
                        aspect-ratio="1"
                        height="100%"
                      />
                    </v-avatar>
                    </td>
                </template>
                  <template v-slot:[`item.actions`]="{ item }">
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }"
                      >
                        <v-btn
                          v-bind="attrs"
                          v-on="on"
                          rounded
                          small
                          dark
                          icon
                          class="ra-border-button mt-3 mb-3"
                          @click="openDialogAddAprover('edit', item, dataSecLeader.indexOf(item), 'approver')"
                        >
                          <template v-slot>
                            <img width="17" height="17" src="@/assets/icons/edit-icon.png" >
                          </template>
                        </v-btn>
                      </template>
                      <span class="label-table-action">จัดการผู้ดูแล</span>
                    </v-tooltip>
                    <v-tooltip bottom>
                      <template v-slot:activator="{ attrs }">
                        <v-btn
                          v-bind="attrs"
                          rounded
                          dark
                          small
                          icon
                          class="ra-border-button mt-3 mb-3 ml-2"
                          @click="checkRemove(item, 'approver')"
                        >
                          <template v-slot>
                            <img width="17" height="17" src="@/assets/icons/delete-icon.png" >
                          </template>
                        </v-btn>
                      </template>
                      <span class="label-table-action">ลบผู้ดูแล</span>
                    </v-tooltip>
                  </template>
                </v-data-table> -->
                <!-- ทุกสิทธิ์สามารเห็น แก้ไขได้ -->
                <v-data-table
                  v-else
                  :headers="filterHeader"
                  :items="dataSecLeader"
                  class="elevation-0"
                  :search="search"
                  :loading="loading"
                  loading-text="Loading... Please wait"
                  :footer-props="{
                    'items-per-page-options': [15, 30, 50, 100, -1],
                    'items-per-page': 15
                  }"
                  :server-items-length="total || -1"
                  @update:items-per-page="changePerPage"
                  @update:page="changePage"
                  disable-sort
                  dense
                  :page.sync="pagination.current"
                >
                  <template v-slot:[`item.userImg`]="{ item }">
                  <td style="width: fit-content !important;" class="py-3">
                    <v-avatar
                      size="50"
                      rounded
                      >
                      <v-img
                        class="card-header-userimg-border"
                        cover
                        :src="item.failed_image ? require('@/assets/icons/no_user.png') : item.userImg"
                        :alt="item.employeeId"
                        v-on:error="onImgErrorSecLeader(item.approverNo)"
                        aspect-ratio="1"
                        height="100%"
                      />
                    </v-avatar>
                    </td>
                </template>
                  <template v-slot:[`item.actions`]="{ item }">
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }"
                      >
                        <v-btn
                          v-if="rights.edit"
                          v-bind="attrs"
                          v-on="on"
                          rounded
                          small
                          dark
                          icon
                          class="mt-3 mb-3"
                          @click="openDialogAddAprover('edit', item, dataSecLeader.indexOf(item), 'approver')"
                        >
                          <template v-slot>
                            <v-icon small dark class="icon-eye-color">mdi-pencil-outline</v-icon>
                          </template>
                        </v-btn>
                      </template>
                      <span class="label-table-action">จัดการผู้ดูแล</span>
                    </v-tooltip>
                    <v-tooltip bottom>
                      <template v-slot:activator="{ attrs }">
                        <v-btn
                          v-if="rights.del"
                          v-bind="attrs"
                          rounded
                          dark
                          small
                          icon
                          class="mt-3 mb-3 ml-2"
                          @click="checkRemove(item, 'approver')"
                        >
                          <template v-slot>
                            <v-icon small dark color="error">mdi-delete-outline</v-icon>
                          </template>
                        </v-btn>
                      </template>
                      <span class="label-table-action">ลบผู้ดูแล</span>
                    </v-tooltip>
                  </template>
                </v-data-table>
              </div>
            </div>
          </v-tab-item>
        </v-tabs-items>
      </v-tabs>
      </v-container>
    </v-card-text>
    <!-- เฉพาะ admin -->
    <!-- <v-card-actions v-if="approveRole !== 'Super Admin'">
      <v-spacer></v-spacer>
      <v-btn class="" color="#2BA197" dark @click="closeDialog">ปิด</v-btn>
      <v-spacer></v-spacer>
    </v-card-actions>
    <v-card-actions v-else>
      <v-spacer></v-spacer>
      <v-btn class="" color="#2BA197" dark @click="closeDialog">ปิด</v-btn>
      <v-btn v-if="chkSubmitData === true" width="100" class="ma-0 ml-2" color="grey" depressed disabled @click="updateSecLeader()">บันทึกข้อมูล</v-btn>
      <v-btn v-else width="100" class="ma-0 ml-2" color="#2BA197" dark @click="updateSecLeader()">บันทึกข้อมูล</v-btn>
      <v-spacer></v-spacer>
    </v-card-actions> -->
    <!-- เห็นทุกสิทธิ์ -->
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn class="" color="#2BA197" dark @click="closeDialog">ปิด</v-btn>
      <v-btn v-if="chkSubmitData === true" width="100" class="ma-0 ml-2" color="grey" depressed disabled @click="updateSecLeader()">บันทึกข้อมูล</v-btn>
      <v-btn v-else width="100" class="ma-0 ml-2" color="#2BA197" dark @click="updateSecLeader()">บันทึกข้อมูล</v-btn>
      <v-spacer></v-spacer>
    </v-card-actions>
  </v-card>
  </v-dialog>
  <v-dialog v-model="dialogDeleteApprover" max-width="500px">
    <v-card height="170px">
      <v-card-title class="ra-head-text-bold justify-center pa-5">ต้องการลบข้อมูลนี้ ใช่หรือไม่?</v-card-title>
      <v-card-text class="justify-center text-center">
      <span v-if="titleDialog === 'approver'" class="ra-head-text justify-center">คุณแน่ใจหรือว่าต้องการลบข้อมูลพนักงานคนนี้</span>
      <span v-else-if="titleDialog === 'temporaryer'" class="ra-head-text justify-center">คุณแน่ใจหรือว่าต้องการลบข้อมูลผู้รักษาการคนนี้</span>
      </v-card-text>
      <v-card-actions class="">
        <v-spacer></v-spacer>
        <v-btn class="ra-button1" color="#2BA197" outlined @click="dialogDeleteApprover = false">ยกเลิก</v-btn>
        <v-btn class="ra-button1" color="#2BA197" dark @click="removeApprover(itemConfirmDelete, titleDialog)">ยืนยัน</v-btn>
        <v-spacer></v-spacer>
      </v-card-actions>
    </v-card>
  </v-dialog>
  <v-dialog v-model="dialogSubmitConfirm" max-width="550px" persistent>
    <v-card >
      <v-card-title class="ra-head-text-bold justify-center pa-5">ต้องการปิดหน้านี้ใช่ไหม</v-card-title>
      <v-card-text class="justify-center text-center">
      <span class="ra-head-text justify-center" style="font-size: 16px;">มีการเปลี่ยนแปลงข้อมูล คุณต้องการบันทึกข้อมูลหรือไหม</span>
      </v-card-text>
      <v-card-text class="justify-center text-center">
        <v-btn class="ra-button1 mb-3" width="70%" color="#2BA197" dark @click="updateSecLeader()">ฉันแน่ใจ และบันทึกข้อมูล</v-btn>
        <v-btn class="ra-button1 mb-3" width="70%" color="#2BA197" outlined @click="dialogMember = false, dialogSubmitConfirm = false, clearValue()">ฉันแน่ใจ และไม่บันทึกข้อมูล  </v-btn>
        <v-btn class="ra-button1 mb-3" width="70%" color="#757575" text outlined dark @click="dialogSubmitConfirm = false">ยกเลิก</v-btn>
      </v-card-text>
    </v-card>
  </v-dialog>
  <DialogAddAprover/>
</div>
</template>

<script>
import {
  getLeaderLsit,
  getMemberLsit,
  hostImageUrlv3,
  updateSecLeader,
  getMemberFilter
} from '@/API/API'
import { EventBus } from '@/EventBus'
import swal from 'sweetalert'
// import { OverlayLoading } from '@/components/index'
import OverlayLoading from '../../_template/OverlayLoading'
import DialogAddAprover from '../../manageCompany/_dialog/dialogAddApprover'
// import TableMember from './tableMember'
export default {
  components: {
    // TableMember
    DialogAddAprover,
    OverlayLoading
  },
  data () {
    return {
      loading: false,
      dialogMember: false,
      dialogDeleteApprover: false,
      dialogSubmitConfirm: false,
      chkSubmitDataOld: true,
      textTitle: '',
      preName: '',
      orgChartId: '',
      leaderImage: '',
      leaderName: '',
      leaderLineOfWork: '',
      leaderChartHeader: '',
      leaderEmail: '',
      failed_image: false,
      failed_imageLeader: false,
      countMember: 0,
      search: '',
      selectFilter: [],
      tab: null,
      items: [
        {
          id: 1,
          nameBusiness: 'สมาชิก',
          count: 1
        },
        {
          id: 2,
          nameBusiness: 'รองหัวหน้า',
          count: 1
        }
      ],
      headers: [
        {
          text: 'ลำดับ',
          align: 'start',
          sortable: false,
          value: 'no'
        },
        { text: 'รูปภาพ', value: 'memberImg', align: 'start' },
        { text: 'ชื่อ-สกุล', value: 'memberName' }
        // { text: 'จัดการ', value: 'actions', sortable: false }
        // { text: 'Actions', value: 'actions', sortable: false }
      ],
      headersSecLeader: [
        {
          text: 'ลำดับ',
          align: 'start',
          sortable: false,
          value: 'approverNo'
        },
        { text: 'รูปภาพ', value: 'userImg', align: 'start' },
        { text: 'ชื่อ-สกุล', value: 'approverName' }
        // { text: 'Actions', value: 'actions', sortable: false }
      ],
      headersSecLeaderAdmin: [
        {
          text: 'ลำดับ',
          align: 'start',
          sortable: false,
          value: 'approverNo'
        },
        { text: 'รูปภาพ', value: 'userImg', align: 'start' },
        { text: 'ชื่อ-สกุล', value: 'approverName' },
        { text: 'จัดการ', value: 'actions', sortable: false }
        // { text: 'Actions', value: 'actions', sortable: false }
      ],
      itemCompany: [
        'INET',
        'OGS'
      ],
      employeeData: [],
      dataSecLeader: [],
      dataMember: [],
      userIdList: [],
      userIdListOld: [],
      titleDialog: '',
      itemConfirmDelete: [],
      total: -1,
      perPage: 15,
      page: 1,
      approveRole: localStorage.approveRole,
      pagination: {}
    }
  },
  beforeDestroy () {
    EventBus.$off('addAprover')
    EventBus.$off('setApproveRole')
    EventBus.$off('opendialogmember')
    EventBus.$off('closeApprover')
  },
  mounted () {
    EventBus.$on('opendialogmember', this.openDialogMember)
    EventBus.$on('addAprover', this.add)
    EventBus.$on('setApproveRole', this.setApproveRole)
    EventBus.$on('closeApprover', this.closeApprover)
    // EventBus.$on('opendialogmemberDepartment', this.openDialogMember)
  },
  created () {
    this.url = process.env.VUE_APP_API_URL
    this.port = process.env.VUE_APP_API_PORT
    this.api = this.url + ':' + this.port
  },
  watch: {
    tab () {
      this.search = ''
      this.pagination = {}
    }
  },
  computed: {
    imgUser () {
      return this.failed_imageLeader ? require('@/assets/icons/no_user.png') : this.leaderImage
    },
    chkSubmitData () {
      var temp = JSON.stringify(this.userIdList)
      var tempOld = JSON.stringify(this.userIdListOld)
      if (temp === tempOld) {
        return true
      } else {
        return false
      }
    },
    rights () {
      return this.$store.getters.getPermissionsByRoute(this.$route.path)
    },
    filterHeader () {
      const canManage = this.rights.edit && this.rights.del
      if (!canManage) {
        return this.headersSecLeaderAdmin.filter(header => header.value !== 'actions')
      }
      return this.headersSecLeaderAdmin
    }
  },
  methods: {
    async setApproveRole () {
      this.approveRole = localStorage.approveRole
    },
    closeApprover () {
      this.loading = false
    },
    onImgError (i) {
      console.log('index', i)
      this.dataMember[i].failed_image = true
    },
    onImgErrorSecLeader (i) {
      this.dataSecLeader[i].failed_image = true
    },
    onImgErrorLeader (event) {
      this.failed_imageLeader = true
    },
    changePerPage (value) {
      this.perPage = value
      // this.initDataTable()
    },
    changePage (value) {
      this.page = value
      // this.initDataTable()
    },
    openDialogMember (value, id) {
      this.loading = true
      this.orgChartId = id
      this.search = ''
      this.initDataLeader()
    },
    openDialogAddAprover (action, item, index, type) {
      this.loading = true
      console.log('เพิ่มพนักงาน', item)
      EventBus.$emit('openDialogAddAprover', true, item, action, index, type)
      // setTimeout(() => {
      //   this.loading = false
      // }, 2000)
    },
    add (value, index, action, type) {
      // var today = new Date()
      // var date = today.getDate() + '-' + (today.getMonth() + 1) + '-' + today.getFullYear()
      var filterValue = this.dataSecLeader.filter(r => {
        if (this.leaderName === value.name) {
          return r
        } else {
          if (r.approverName === value.name) {
            return r
          }
        }
      })
      if (type === 'approver') {
        if (action === 'add') {
          if (filterValue.length > 0) {
            swal('คำเตือน', 'คุณได้เพิ่มพนักงานคนนี้แล้ว', 'warning')
          } else {
            // console.log('No Dup', filterValue)
            this.dataSecLeader.push({
              approverNo: this.dataSecLeader.length + 1,
              _id: value.id,
              employeeId: value.employeeId,
              approverName: value.name,
              position: value.position,
              email: value.email,
              userImg: value.userImg,
              approveType: value.approveType,
              failed_image: false
            })
            this.userIdList.push({
              userId: value.id,
              companyId: value.companyId
            })
            // console.log('add temporaryer:', this.temporaryer)
          }
        } else if (action === 'edit') {
          if (filterValue.length > 0) {
            swal('คำเตือน', 'คุณได้เพิ่มพนักงานคนนี้แล้ว', 'warning')
          } else {
            this.dataSecLeader[index].approverNo = index + 1
            this.dataSecLeader[index]._id = value.id
            this.dataSecLeader[index].employeeId = value.employeeId
            this.dataSecLeader[index].approverName = value.name
            this.dataSecLeader[index].position = value.position
            this.dataSecLeader[index].email = value.email
            this.dataSecLeader[index].approveType = value.approveType
            this.dataSecLeader[index].userImg = value.userImg
            this.dataSecLeader[index].failed_image = value.failed_image || false

            this.userIdList[index].userId = value.id
            this.userIdList[index].companyId = value.companyId
          }
        }
      }
      this.loading = false
    },
    async initDataLeader () {
      this.employeeData = []
      this.userIdList = []
      const tempSecLeader = []
      const tempMember = []
      // const temp = []
      const obj = {
        orgChartId: this.orgChartId
      }
      try {
        const res = await getLeaderLsit(obj, this.$store.state.token)
        if (res.success) {
          // this.leaderName = `${res.result.leaderData.leaderName}${res.result.temporaryLeader ? ' (รก.)' : ''}`
          this.leaderName = `${res.result.leaderData.leaderName}${res.result.temporaryLeader ? ' (รก.)' : ''}`
          this.leaderName = this.leaderName === '- (รก.)' ? '-' : this.leaderName
          this.leaderChartHeader = res.result.orgChartName
          this.leaderLineOfWork = res.result.orgChartType
          this.leaderEmail = res.result.leaderData.emailOneId
          this.countMember = res.result.memberData.length
          if (res.result.leaderData.leaderImg === '') {
            // this.leaderImage = this.api + '/uploads/users_img/' + res.result.leaderData.leaderImg
            this.leaderImage = `${hostImageUrlv3}/_/${res.result.leaderData.emailOneId}`
          } else {
            this.leaderImage = `${hostImageUrlv3}/${res.result.leaderData.leaderImg}/${res.result.leaderData.leaderImg.emailOneId}`
          }
          // this.dialogMember = true
          // this.loading = false
          if (res.result.memberData.length !== 0) {
            res.result.memberData.map((el, index) => {
              if (el.memberImg === '') {
                el.memberImg = `${hostImageUrlv3}/_/${el.emailOneId}`
              } else {
                el.memberImg = `${hostImageUrlv3}/${el.memberImg}/${el.emailOneId}`
              }
              tempMember.push({
                no: index + 1,
                failed_image: false,
                ...el
              })
              this.dataMember = tempMember
            })
          }
          if (res.result.secondaryLeader.length !== 0) {
            res.result.secondaryLeader.map((el, index) => {
              if (el.secondaryLeaderImg === '') {
                el.secondaryLeaderImg = `${hostImageUrlv3}/_/${el.emailOneId}`
              } else {
                el.secondaryLeaderImg = `${hostImageUrlv3}/${el.secondaryLeaderImg}/${el.emailOneId}`
              }
              tempSecLeader.push({
                approverNo: index + 1,
                approverName: el.secondaryLeaderName,
                email: el.emailOneId,
                userImg: el.secondaryLeaderImg,
                failed_image: false,
                ...el
              })
              this.userIdList.push({
                userId: el.employeeLeaderId,
                companyId: el.companyId
              })
              this.userIdListOld.push({
                userId: el.employeeLeaderId,
                companyId: el.companyId
              })
              this.dataSecLeader = tempSecLeader
              // console.log('🚀 ~ tempSecLeader', tempSecLeader)
              // var tempRelease = JSON.parse(JSON.stringify(this.userIdListOld))
              // this.userIdListOld = JSON.parse(JSON.stringify(tempRelease))
            })
          }
          this.dialogMember = true
          // this.initDataTable()
        } else {
          // console.log('Res', res)
        }
      } catch (error) {
        // alert(error)
        console.log(error)
      } finally {
        this.loading = false
      }
    },
    async getMemberFilter () {
      // const token = this.tokenUser
      // const obj = {
      //   orgChartId: this.orgChartId
      // }
      try {
        const res = await getMemberFilter(this.orgChartId, this.$store.state.token)
        if (res.success) {
          if (res.result.length) {
            // this.selectData = res.result
            this.selectFilter = res.result[0].name
          }
        }
      } catch (error) {
        // alert(error)
        // console.log(error)
      } finally {
        // this.loading = false
      }
    },
    async initDataTable () {
      // this.loading = true
      this.employeeData = []
      const temp = []
      const obj = {
        _id: this.orgChartId,
        nameId: [this.search],
        limit: this.perPage,
        page: this.page
      }
      try {
        const res = await getMemberLsit(obj, this.$store.state.token)
        if (res.success) {
          res.result.map((el, index) => {
            if (el.userImg === '') {
              el.userImg = `${hostImageUrlv3}/_/${el.emailOneId}`
            } else {
              el.userImg = `${hostImageUrlv3}/${el.memberImg}/${el.emailOneId}`
            }
            temp.push({
              no: index,
              failed_image: false,
              ...el
            })
          })
          this.dataSecLeader = temp
          this.dialogMember = true
          // this.getMemberFilter()
        }
        // this.loading = false
      } catch (error) {
        // alert(error)
        console.log(error)
      } finally {
        this.loading = false
      }
    },
    async updateSecLeader () {
      // this.loading = true
      const obj = {
        orgChartId: this.orgChartId,
        // orgChartId: '613869af6cf96c0d78d0d694',
        dataUpdate: this.userIdList
      }
      try {
        const res = await updateSecLeader(obj, this.$store.state.token)
        if (res.success) {
          swal('สำเร็จ', 'คุณได้ทำการบันทึกข้อมูล เรียบร้อยแล้ว', 'success', {
            button: false,
            timer: 2000
          })
          // await this.initDataLeader()
          // this.chkSubmitDataOld = false
          this.dialogSubmitConfirm = false
          this.dialogMember = false
          this.clearValue()
        }
        // this.loading = false
      } catch (error) {
        swal('ผิดพลาด', 'กรุณาลองใหม่อีกครั้ง', 'error')
        this.dialogSubmitConfirm = false
        // alert(error)
        console.log(error)
      } finally {
        this.loading = false
      }
    },
    checkRemove (item, type) {
      this.itemConfirmDelete = []
      this.titleDialog = type
      this.itemConfirmDelete = item
      this.dialogDeleteApprover = true
    },
    removeApprover (item, type) {
      // console.log('removeApprover', this.approver.indexOf(item))
      if (type === 'approver') {
        this.dataSecLeader.splice(this.dataSecLeader.indexOf(item), 1)
        this.userIdList.splice(this.userIdList.indexOf(item), 1)
        this.itemConfirmDelete = []
        this.itemIndex = 0
        this.dialogDeleteApprover = false
      }
    },
    editCompany (value) {
      this.textTitle = ''
      // this.dialogCreate = true
      this.textTitle = value
    },
    clearValue () {
      this.userIdList = []
      this.userIdListOld = []
      this.search = ''
      this.dataMember = []
      this.dataSecLeader = []
      this.chkSubmitData = false
    },
    closeDialog () {
      if (this.chkSubmitData === false) {
        this.dialogSubmitConfirm = true
      } else {
        this.dialogMember = false
        this.clearValue()
        // this.initDataLeader()
      }
      // EventBus.$emit('closedialogcreate', this.dialogCreate)
    },
    submitEdit (preName) {
      this.dialogCreate = false
      this.preName = ''
    }
  }
}
</script>
<style scoped>
/* .txt-font {
  font-family: 'Sarabun', sans-serif;
  font-weight: normal;
  font-size: 18px;
} */
.txt-font {
  /* font-family: 'Sarabun', sans-serif;
  font-weight: normal;
  font-size: 18px; */
  font-family: 'Sarabun', sans-serif;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 5px;
  color: #757575;
}
.txt-head {
  font-family: 'Sarabun', sans-serif;
  font-weight: bold;
}
.txt-leader-title {
  font-family: 'Sarabun', sans-serif !important;
  font-weight: bold;
  font-size: 1.2rem;
}
.dialog-memeber-title {
  font-family: 'Sarabun', sans-serif !important;
  font-weight: bold;
  font-size: 1.5rem;
}
.border-img {
  border-radius: 15px;
}
.ra-head-text-bold {
  font-family: 'Sarabun', sans-serif;
  font-style: normal;
  font-weight: bold;
  font-size: 18px;
  line-height: 24px;
  /* identical to box height, or 150% */

  display: flex;
  align-items: center;

  /* Color / #2BA197 / Hover */

  color: #2BA197;
}
.ra-head-text {
  font-family: 'Sarabun', sans-serif;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 22px;
}
</style>
